export default __webpack_public_path__ + "static/news3-675e907182c16b02ecf6c96ea9715e40.jpg";